import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Collections from "Components/Collections";
// ------------------------------------------------------
import {
  addCustomColumn,
  updateCustomColumn,
  eraseCustomColumn,
} from "Redux/collections/actions";

// ------------------------------------------------------
// ------------------------------------------------------
const Columns = () => {
  const dispatch = useDispatch();
  const { collections, current } = useSelector((state) => state.project);
  const collection = collections.find((c) => c.id === current);

  if (!collection) return <Collections />;

  const custom = collection.custom || [];

  return (
    <Collections>
      <div className="table-container">
        <table className="table is-striped is-hover">
          <thead>
            <tr>
              <th className="custom-td">Column</th>
              <th className="custom-td">Value</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {custom.map((column, index) => (
              <Row
                key={`${collection.id}-${index}`}
                column={column}
                collectionid={collection.id}
                index={index}
              />
            ))}
          </tbody>
        </table>
        <button
          className="button is-small"
          onClick={() => {
            dispatch(addCustomColumn(collection.id));
          }}
        >
          <span className="icon is-small">
            <i className="fa-duotone fa-plus" />
          </span>
        </button>
      </div>
    </Collections>
  );
};

export default Columns;

// ------------------------------------------------------
// ------------------------------------------------------
const Row = ({ column, index, collectionid }) => {
  const dispatch = useDispatch();
  return (
    <tr>
      <Input
        value={column.key}
        onSubmit={(key) => {
          dispatch(updateCustomColumn(collectionid, index, key, column.value));
        }}
      />
      <Input
        value={column.value}
        onSubmit={(val) => {
          dispatch(updateCustomColumn(collectionid, index, column.key, val));
        }}
      />
      <td style = {{verticalAlign: "bottom"}}>
        <button
          className="delete is-small"
          onClick={() => {
            dispatch(eraseCustomColumn(collectionid, index));
          }}
        />
      </td>
    </tr>
  );
};

// ------------------------------------------------------
// ------------------------------------------------------
const Input = ({ value, onSubmit }) => {
  const [val, setVal] = useState("");
  const [edit, setEdit] = useState(false);

  useEffect(() => {
    setVal(value);
    if (value === "") setEdit(true);
  }, [value]);

  const submit = () => {
    if (val !== "") setEdit(false);
    onSubmit(val);
  };

  if (!edit) {
    return (
      <td
        className="custom-td is-clickable"
        onClick={() => {
          setEdit(true);
        }}
      >
        {value}
      </td>
    );
  }

  return (
    <td className="custom-td">
      <input
        className="input is-small"
        type="text"
        value={val}
        onChange={(evt) => {
          setVal(evt.target.value);
        }}
        onKeyDown={(evt) => {
          evt.key === "Enter" && submit();
        }}
        onBlur={submit}
      />
    </td>
  );
};
